import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, API_NAME, NAME, EXPORT_FILE_NAME } from './constants';


class SestavyApi extends BaseApi {
	constructor() {
		super(DMS_MODULE, API_NAME);
	}

	async GetRealtimeInventoryReport(realTimeInventoryUrlParameters: any, languageId: any, columnSequence : any) {
		return this.downloadXlsxReport(
			`/${DMS_MODULE}/${NAME}/GetRealtimeInventoryReport?${realTimeInventoryUrlParameters}&LanguageId=${languageId}&IsExport=${true}&ColumnSequence=${columnSequence}`, EXPORT_FILE_NAME,
		);
	}
}


export const apiProvider = new SestavyApi();
